import { GenIcon } from '../helpers/IconBase.es.js';

const CartFilled = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M18 21H6C5.46957 21 4.96086 20.7893 4.58579 20.4142C4.21071 20.0391 4 19.5304 4 19V8.5C4 8.10218 4.15804 7.72064 4.43934 7.43934C4.72064 7.15804 5.10218 7 5.5 7H18.5C18.8978 7 19.2794 7.15804 19.5607 7.43934C19.842 7.72064 20 8.10218 20 8.5V19C20 19.5304 19.7893 20.0391 19.4142 20.4142C19.0391 20.7893 18.5304 21 18 21ZM15.996 9.55006C16.1277 9.54953 16.2581 9.57501 16.3799 9.62503C16.5017 9.67504 16.6124 9.74861 16.7057 9.84153C16.799 9.93445 16.873 10.0449 16.9235 10.1664C16.974 10.288 17 10.4184 17 10.5501C17 10.7477 16.9414 10.9409 16.8317 11.1052C16.722 11.2696 16.5661 11.3977 16.3836 11.4735C16.2011 11.5493 16.0003 11.5694 15.8064 11.5311C15.6125 11.4929 15.4343 11.398 15.2943 11.2586C15.1543 11.1191 15.0587 10.9413 15.0197 10.7476C14.9807 10.5539 14.9999 10.3529 15.075 10.1701C15.1501 9.98734 15.2776 9.83089 15.4415 9.72053C15.6054 9.61016 15.7984 9.55085 15.996 9.55006ZM8.42972 9.62503C8.30793 9.57501 8.17747 9.54953 8.0458 9.55006C7.8482 9.55085 7.65525 9.61016 7.49133 9.72053C7.32741 9.83089 7.19986 9.98734 7.12478 10.1701C7.0497 10.3529 7.03048 10.5539 7.06951 10.7476C7.10854 10.9413 7.20409 11.1191 7.34411 11.2586C7.48412 11.398 7.66231 11.4929 7.85618 11.5311C8.05006 11.5694 8.25092 11.5493 8.43341 11.4735C8.61589 11.3977 8.77184 11.2696 8.88155 11.1052C8.99125 10.9409 9.0498 10.7477 9.0498 10.5501C9.04981 10.4184 9.02381 10.288 8.9733 10.1664C8.9228 10.0449 8.84879 9.93445 8.7555 9.84153C8.66221 9.74861 8.5515 9.67504 8.42972 9.62503Z",
          fill: "#82869E"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M8 7V6.75C8 5.75544 8.39509 4.80161 9.09835 4.09835C9.80161 3.39509 10.7554 3 11.75 3H12.25C12.7425 3 13.2301 3.097 13.6851 3.28545C14.14 3.47391 14.5534 3.75013 14.9017 4.09835C15.2499 4.44657 15.5261 4.85997 15.7145 5.31494C15.903 5.76991 16 6.25754 16 6.75V7",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};

export { CartFilled };
